const CONFLICT_USER_COLORS = [
  '#F5A36C',
  '#6ACCA3',
  '#F5D57F',
  '#F57F83',
  '#7FB1F5',
  '#A393F5',
  '#52CCC2',
];

export default CONFLICT_USER_COLORS;
